import { formatFromIsoToFrDate, formatFromIsoToFrDateTime } from '@/utils/date';

export default {
  methods: {
    dateFormatter(date) {
      if (date) {
        return formatFromIsoToFrDate(date);
      }
      return null;
    },
    dateTimeFormatter(date) {
      if (date) {
        return formatFromIsoToFrDateTime(date);
      }
      return null;
    },
  },
};
